import { type Href } from 'expo-router';
import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { ListRow } from '@/components/ui/ListRow';
import { Surface } from '@/components/ui/Surface';
import { Text } from '@/components/ui/Text';

export interface TemplateRowProps {
  icon?: string | null;
  title: string;
  stepCount: number;
  /** e.g. "run 3d ago" or "never run". */
  meta?: string;
  shared?: boolean;
  live?: boolean;
  /** Navigation target — renders a real `<a href>` on web (cmd/middle-click, etc.). */
  href?: Href;
  onPress?: () => void;
  className?: string;
}

/** A template card in the Home / start-a-run lists. */
export function TemplateRow({
  icon,
  title,
  stepCount,
  meta,
  shared,
  live,
  href,
  onPress,
  className,
}: TemplateRowProps) {
  const bits = [`${stepCount} step${stepCount === 1 ? '' : 's'}`];
  if (meta) bits.push(meta);
  if (live) bits.push('live');
  else if (shared) bits.push('shared');

  return (
    <Surface className={cn('overflow-hidden', className)}>
      <ListRow
        href={href}
        onPress={onPress}
        leading={
          <View className="h-11 w-11 items-center justify-center rounded-xl bg-well">
            <Text className="text-2xl">{icon ?? '📋'}</Text>
          </View>
        }
        title={title}
        subtitle={bits.join(' · ')}
      />
    </Surface>
  );
}
